import type { SVGAttributes } from "react"

import RebulkLogo from "./rebulk-logo"

export default function AppLogoIcon(props: SVGAttributes<SVGElement>) {
  return <RebulkLogo className={props.className} />
}
